module.exports = "/assets/4b5d27bf2d40db9046d964a2d5149e65.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/3K.png
// module id = 2142
// module chunks = 0